export const getApiErrorMessage = (error, fallback) => {
  const data = error && error.response && error.response.data;

  if (data && data.message) return data.message;
  if (data && data.errors && data.errors.length > 0) return data.errors.join(' ');

  return fallback;
};
